import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { Http, Response } from '@angular/http';
// creation and utility methods
import { Observable, of, forkJoin } from 'rxjs';
import { LookupModel } from '../../models/lookup-model';
import { LookupEntity } from '../../models/lookup-entity';
import { environment } from 'environments/environment';
import { ResultDetails } from '../../models/result-details';
import { LookupKeyValue } from '../../models/lookup-key-value';

@Injectable({
  providedIn: 'root'
})

export class LookupService {

  private lookupServiceUrl: string;

  lookupEntities: { [id: number]: LookupKeyValue[]; } = {};

  constructor(private http: HttpClient) {
    this.lookupEntities = {};
    this.lookupServiceUrl = environment.lookupServiceUrl;
  }

  loadLookups(lookupTypes: LookupEntity[]): Observable<boolean> {
    //let result: Observable<boolean>;
    var obersrvablArray: Observable<any>[] = [];
    for (var i = 0; i < lookupTypes.length; i++) {
      var url = "";
      if (lookupTypes[i].FilterValue == undefined) {
        url = this.lookupServiceUrl + '/' + lookupTypes[i].lookupType;
      } else { url = this.lookupServiceUrl + '/' + lookupTypes[i].lookupType + '?filter=' + lookupTypes[i].FilterValue;}
      obersrvablArray.push(this.http.get<ResultDetails>(url));
    }

    return new Observable<boolean>(observer => {
      forkJoin(obersrvablArray).subscribe(response => {
        this.handleRetrievedLookup(response);
      }, error => {
        this.handleError(error);
        observer.error(false);
      }, () => {
        this.compeleteRetrievingLookups();
        observer.next(true);
      });
    });
  }


  //private IsNewLookupExistsInLookupEntities(lookupType: id)

  private handleRetrievedLookup(response: any): void {
    for (var i = 0; i < response.length; i++) {
      let lookup: LookupModel = response[i].Data;
      if (!this.lookupEntities[lookup.LookupType as number])
        this.lookupEntities[lookup.LookupType] = lookup.LookupValues.filter(x => x != null);


      //if (!this.lookupEntities.filter(x => x.lookupType == lookup.lookupType)[0])
      //  this.lookupEntities.push(lookup);
    }
  }

  private handleError(error): void {

  }

  private compeleteRetrievingLookups(): void {
  }

  private test(): void {

    let obj: any = {
      "IsSubmitted": true,
      "CountryId": "32443",
      "MissionId": "43213",
      "PassportNo": "431423",
      "IssuanceOfPassportId": "747tyr",
      "DateOfIssuancePassport": "12/10/2014",
      "DateOfExpirePassport": "12/10/2024",
      "ReasonsForStayingOutside": "Test2",
      "FilesId": "reer44334",
      "DurationOfStayOutside": "2",
      "ExtraMobileNumber": "6357537477",
      "CitizenshipId": "7gfgfgf",
      "AttachmentId": "0CA692EE-E582-48F8-AAE2-81CEFDF26553",
      "NationalId": "0CA692EE-E582-48F8-AAE2-81CEFDF26553",
      "ReasonsBehindDamagedPassportId": "0CA692EE-E582-48F8-AAE2-81CEFDF26553",
      "SupportiveOfficialDocumentId": "0CA692EE-E582-48F8-AAE2-81CEFDF26553",
      "CopyOfPassportId": "0CA692EE-E582-48F8-AAE2-81CEFDF26553"
    }
    //let apiHeader = new HttpHeaders();
    //let contentType = apiHeader.append('Content-Type', 'application/json');
    //let aControl = contentType.append("Access-Control-Allow-Methods", "DELETE, POST, GET, OPTIONS");
    //const httpOptions = {
    //  headers: new HttpHeaders({
    //    'Content-Type': 'application/json',
    //    'Accept': 'application/json'
    //  })
    //};

    //this.http.post("http://localhost/MOFAICEServiceWebAPI/api/ServiceDamagedPassport/SaveApplication", obj)
    //  .subscribe(data => {
    //    console.log("DONE.")
    //  });
  }

}
